import Vue from "vue";
import Main from "./main.vue";

import axios from "axios";

Vue.config.productionTip = false;

new Vue({
  render: (h) => h(Main),
  mounted() {
    if ($(".fade-in-item").length) {
      $(window).scroll(function () {
        let s = $(this).scrollTop();
        let a = s + window.innerHeight;

        $(".fade-in-item").each(function () {
          let p = $(this).offset();

          if (a >= p.top && !$(this).hasClass("active")) {
            $(this).addClass("active");
          }

          if (a < p.top && $(this).hasClass("active")) {
            $(this).removeClass("active");
          }
        });
      });
    }
  },
}).$mount("#app");
